import { AddSingleProductToSelectionListResponseOut, SingleActionResponse } from '../../store/api';
import { globalErrorResponse, showNotification } from '../../store/notifications/actions';
import { failSelectionlists, fetchSelectionlists } from '../../store/orderlist/actions';
import { AppDispatch } from '../../store';
import { ListContentSource } from '../../store/constants';
import { ADD_TO_LIST } from '../../store/orderlist/types';

type Params = {
    performChecks: boolean;
    dispatch: AppDispatch;
    setLoading: (loading: boolean) => void;
    source: ListContentSource;
    notificationMessage: string;
    apiCallback: () => Promise<AddSingleProductToSelectionListResponseOut>;
    callback?: () => void;
};

export const singleUpdateToList = ({
    performChecks,
    dispatch,
    setLoading,
    notificationMessage,
    apiCallback,
    callback = () => {},
    source
}: Params): Promise<SingleActionResponse> => {
    setLoading(true);

    // this is responsible for the list total animation
    dispatch({ type: ADD_TO_LIST });

    return apiCallback()
        .then(data => mapSingleResponseOutToSingleActionResponse(data))
        .then(data => {
            if (data.alreadyInListProducts.length < 1) {
                dispatch(showNotification(notificationMessage));
                dispatch(fetchSelectionlists());

                callback();
            }
            return data;
        })
        .catch(error => {
            if (!performChecks) {
                dispatch(failSelectionlists(error, source));
            } else {
                dispatch(globalErrorResponse(error));
            }
            return Promise.reject(error);
        })
        .finally(() => setLoading(false));
};

export const mapSingleResponseOutToSingleActionResponse = (
    data: AddSingleProductToSelectionListResponseOut
): SingleActionResponse => {
    return {
        alreadyInListProducts: data.alreadyInListProduct ? [data.alreadyInListProduct] : [],
        preOrderedProducts: []
    };
};
